import Home from "components/Home";

export default Home;



// WEBPACK FOOTER //
// ./src/containers/Home/index.js